export default __webpack_public_path__ + "img/toggle-on.6c8ace27.svg";